class Video {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-video'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
    }

    toggleVideoState(shouldPlay) {
        if (shouldPlay) {
            this.$root.play();
        } else {
            this.$root.pause();
        }
    }

    loadVideo (callback) {
        const sourcesJson = this.$root.getAttribute(this.settings.initAttr);

        if (sourcesJson) {
            try {
                const sources = JSON.parse(sourcesJson);
                const isPreferred = source => source.type.startsWith('video/mp4') === Boolean(window.hevcAlpha);

                // WebKit gets HEVC-alpha first, all others WebM (window.hevcAlpha: components/video/alpha-source.html.twig)
                sources.sort((a, b) => isPreferred(b) - isPreferred(a));
                sources.forEach(source => {
                    const $source = document.createElement('source');
                    $source.src = source.src;
                    $source.type = source.type;
                    this.$root.appendChild($source);
                });
            } catch (err) {
                console.error('Invalid video sources JSON:', err);
            }
        }

        if (this.$root.readyState < 2) {
            this.$root.addEventListener('loadeddata', () => {
                if (typeof callback === 'function') {
                    callback();
                }
            }, { once: true });

            this.$root.load();
        } else {
            if (typeof callback === 'function') {
                callback();
            }
        }
    }
}

export { Video };
